<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import UsersList from "@/components/users-list";
import SuppliersApi from "@/services/suppliers-api";
import CustomerApi from "@/services/customers-api";

export default {
  page: {
    title: "Gestion des abonnements",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout,UsersList},
  data() {
    return {
      allLaboratoriesCount:null,
      allprovidersCount:null,
      allCustomersCount:null,

    };
  }, 
    mounted(){
     /*  this.getLaboratoriesCount();
      this.getprovidersCount()
      this.getCountCustomers(); */

  },
    methods: {
       getLaboratoriesCount(){
      SuppliersApi.getCountLabortoryAndProvide(0).then(
        result => {
          this.allLaboratoriesCount=result;
        }
      )
    },
    getprovidersCount(){
      SuppliersApi.getCountLabortoryAndProvide(1).then(
        result => {
          this.allprovidersCount=result;
        }
      )
    },

    getCountCustomers(){
      CustomerApi.getCountCustomers().then(
        result => {
          this.allCustomersCount=result;
        }
      )
    },

    }
};
</script>
<template>
  <Layout>
    <div class="row pt-4 pb-4">
      <div class="col-lg-12">
        <div class="card" style="border:1px solid rgb(205, 211, 217);">
          <div class="card-body">
            <h2 class="card-title font-size-25" style="font-size:25px;">Liste des Utilisateurs</h2>
            <!-- <p class="card-title-desc font-size-14">
              <u><span>{{this.allLaboratoriesCount}}</span> Laboratoires</u> , <u> <span>{{this.allCustomersCount}}</span> Officinaux</u>  et <u><span>{{this.allprovidersCount}}</span> Prestataires</u> de services.
            </p> -->
             <b-tabs content-class="p-3 text-muted">
              <b-tab active class="border-0" lazy>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-briefcase-medical font-size-16"></i>
                  </span>
                  <i class="d-none d-sm-inline-block fas fa-briefcase-medical font-size-16 pr-2"/><span class="d-none d-sm-inline-block font-size-16">Laboratoires</span>
                </template>
                <UsersList :isLaboratory=true />
              </b-tab>
            <b-tab lazy>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-clinic-medical font-size-16"></i>
                  </span>
                  <i class="d-none d-sm-inline-block fas fa-clinic-medical font-size-16 pr-2"/><span class="d-none d-sm-inline-block font-size-16">Officinaux</span>
                </template>
                <UsersList :isCustomer=true />
              </b-tab>
              <b-tab lazy>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-briefcase font-size-16"></i>
                  </span>
                  <i class="d-none d-sm-inline-block fas fa-briefcase font-size-16 pr-2"/><span class="d-none d-sm-inline-block font-size-16">Prestataires</span>
                </template>
                <UsersList :isProvider=true />
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>

  </Layout>
</template>

